import { createAsyncThunk } from "@reduxjs/toolkit";

import api from "api";
import { proceedThunk } from "./utils";

export const foldersListThunk = createAsyncThunk(
  "folder/list",
  proceedThunk(api.takebaker.folders.list)
);

export const createFolderThunk = createAsyncThunk(
  "folder/create",
  proceedThunk(api.takebaker.folders.create)
);

export const updateFolderThunk = createAsyncThunk(
  "folder/update",
  proceedThunk(api.takebaker.folders.update)
);

export const deleteFolderThunk = createAsyncThunk(
  "folder/delete",
  proceedThunk(api.takebaker.folders.delete)
);

export const exportFolderThunk = createAsyncThunk(
  "folder/export",
  async (payload, { rejectWithValue }) => {
    const response = await api.takebaker.folders.download(payload);
    if (!response.ok) {
      const body = await response.json();
      return rejectWithValue(body);
    }

    const contentDisposition = response.headers.get("content-disposition");
    const filenameIndex =
      contentDisposition.indexOf(`filename=`) + "filename=".length;
    const filename = contentDisposition.substr(filenameIndex);

    return { filename, blob: await response.blob() };
  }
);

export const statsFolderThunk = createAsyncThunk(
  "folder/stats",
  proceedThunk(api.takebaker.folders.stats)
);

export const searchFoldersThunk = createAsyncThunk(
  "folder/search",
  proceedThunk(api.takebaker.folders.search)
);
